<template>
  <v-card class="green lighten-4 my-2" style="width: 100%">
    <v-card-title class="green--text">
      <span style="font-family: 'Raleway'; font-weight: 500; color: #4caf50"
        >{{ serie.nome }}™
      </span>
      <v-spacer></v-spacer>
      <v-img :src="serie_img_brand_src" max-height="50" max-width="50" />
    </v-card-title>
    <v-img :src="info_img" height="150"></v-img>
    <v-card-text v-html="formatText(info_serie)" style="font-size: 16px"></v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    serie: Object,
    id_specie: String,
  },
  data() {
    return {
      info_serie: null,
      img_serie_brand_md5: null,
      img_serie_md5: null,
    };
  },
  mounted() {
    this.$store
      .dispatch("fetch_info_serie_by_id", {
        id_specie: this.id_specie,
        id_serie: this.serie.id,
      })
      .then((res) => {
        this.info_serie = res.info_serie;
        this.img_serie_md5 = res.img_serie_info_md5;
        this.img_serie_brand_md5 = res.img_serie_brand_md5;
      });
  },
  computed: {
    info_img() {
      return (
        process.env.VUE_APP_API_ROOT +
        "/specie/" +
        this.id_specie +
        "/serie/" +
        this.serie.id +
        "/info_img?md5=" +
        this.img_serie_md5
      );
    },
    serie_img_brand_src() {
      return (
        process.env.VUE_APP_API_ROOT +
        "/specie/" +
        this.id_specie +
        "/serie/" +
        this.serie.id +
        "/brand_img_serie?md5=" +
        this.img_serie_brand_md5
      );
    },
  },
  methods: {
    formatText(input) {
      // Sostituisce **parola** con <strong>parola</strong>
      return input.replace(/\*\*(.*?)\*\*/g, '<span style="font-weight: bold; font-size: 16px;">$1</span>');
    },
  },
};
</script>